(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_d1c9052"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mw-deferred-factory-video')) {
    customElements.define('mw-deferred-factory-video', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        if (!('IntersectionObserver' in window)) {
          this.loadVideo();
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadVideo();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      loadVideo() {
        const template = this.querySelector('template[data-video-embed]');
        if (this.loaded || !template) return;
        this.loaded = true;
        if (this.observer) this.observer.disconnect();
        const fragment = template.content.cloneNode(true);
        fragment.querySelectorAll('script').forEach(original => {
          const script = document.createElement('script');
          Array.from(original.attributes).forEach(attribute => {
            script.setAttribute(attribute.name, attribute.value);
          });
          script.textContent = original.textContent;
          original.replaceWith(script);
        });
        this.appendChild(fragment);
        template.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
